// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xaJQX","text":"styles_text__2-Exv"};